var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: -11.899,
    y1: 48.694,
    x2: 40.299,
    y2: -8.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#2391c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#378bbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#7f6cb1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin-original-a)",
    d: "M0 0h65.4L0 64.4z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 43.553,
    y1: 149.174,
    x2: 95.988,
    y2: 94.876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#2d8ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#7f6cb1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin-original-b)",
    d: "M128 128L64.6 62.6 0 128z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-c",
    gradientUnits: "userSpaceOnUse",
    x1: 3.24,
    y1: 95.249,
    x2: 92.481,
    y2: 2.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c757a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    stopColor: "#ca5a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#d66779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#e17357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e97c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#ef8324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#f28817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#f48912"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin-original-c)",
    d: "M0 128L128 0H64.6L0 63.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4be5b41cbfa4ca6c675517bcc5055131.svg";
export { ForwardRef as ReactComponent };